var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// Utils
import { generateObjectId } from './objectIdGeneration';
import { hasObjectId } from '../hasObjectId';
import { setObjectId } from './setObjectId';
/**
* @description Attaches a unique generated identifier to the given object if missing, if the given object already has an identifier, the given object is returned.
 *
 * @template T
 * @param {T} values
 * @param {string | null} [pathRelativeToParentObject=null]
 *
 * @return T
 */
export var attachGeneratedObjectIdToObjectOrReturn = function (values, pathRelativeToParentObject) {
    if (pathRelativeToParentObject === void 0) { pathRelativeToParentObject = null; }
    var result = values;
    if (!hasObjectId(result)) {
        result = __assign({}, result);
        var objectId = generateObjectId(result, pathRelativeToParentObject);
        setObjectId(result, objectId);
    }
    return result;
};
//# sourceMappingURL=attachGeneratedObjectIdToObjectOrReturn.js.map